import { PostHogProvider } from "@posthog/react"
import React from "react"
import type { HydrationOptions } from "react-dom/client"
import ReactDOM from "react-dom/client"
import { HydratedRouter } from "react-router/dom"
import { info } from "./init/info"
import { clientInit } from "./init/init"

info()
const { posthog } = await clientInit()

const options: HydrationOptions = {
  // React 19 no longer re-throws render errors; these root options are the place to observe them.
  // TODO Should probably report all three of these to Sentry.
  onCaughtError: (error, errorInfo): void => {
    console.log("💥 Error caught by an error boundary", { error, errorInfo })
  },
  onUncaughtError: (error, errorInfo): void => {
    console.log("💥 Error not caught by any error boundary", { error, errorInfo })
  },
  onRecoverableError: (error, errorInfo): void => {
    console.log("💥 Error automatically recovered from", { error, errorInfo })
  },
}
ReactDOM.hydrateRoot(
  document,
  <PostHogProvider client={posthog}>
    <React.StrictMode>
      <HydratedRouter />
    </React.StrictMode>
  </PostHogProvider>,
  options,
)
